import { FormPage } from "app/pages/public/FormPage";
import { FormThankYouPage } from "app/pages/public/FormThankYouPage";
import FacebookCallback from "app/pages/Auth/FacebookCallback";
import QRFormPage from "app/pages/public/QrFormPage";
import WhsQrPage from "app/pages/public/WhsQrPage";
import VehicleChecklistQrPage from "app/pages/public/VehicleChecklistQrPage";
import WhsReportIncidentPage from "app/pages/public/WhsReportIncidentPage";
import WhsToolboxTalkPage from "app/pages/public/WhsToolboxTalkPage";
import ClientSelectionApprovalPage from "app/pages/project-management/selections-v2/ClientSelectionApprovalPage";

const publicRoutes = {
  id: "public",
  children: [
    {
      path: "/client-selection-approval/:token",
      Component: ClientSelectionApprovalPage,
    },
    {
      path: "/qr/:token",
      Component: QRFormPage,
    },
    {
      path: "/whs/report-incident/:token?",
      Component: WhsReportIncidentPage,
    },
    {
      path: "/whs/toolbox-talk/:token?",
      Component: WhsToolboxTalkPage,
    },
    {
      path: "/whs/:token/toolbox-talk",
      Component: WhsToolboxTalkPage,
    },
    {
      path: "/whs/:token",
      Component: WhsQrPage,
    },
    {
      path: "/whs/vehicle-checklist/:token?",
      Component: VehicleChecklistQrPage,
    },
    {
      path: "/form/:formId",
      Component: FormPage,
    },
    {
      path: "/form-thankyou/:leadId",
      Component: FormThankYouPage,
    },
    {
      path: "/facebook/callback",
      Component: FacebookCallback,
    },
    {
      path: "https://sunnyhomes.com.au/privacy-policy",
      lazy: async () => ({
        Component: (await import("app/pages/legal/Privacy")).default,
      }),
    },
    {
      path: "/terms",
      lazy: async () => ({
        Component: (await import("app/pages/legal/Terms")).default,
      }),
    },
  ],
};

export { publicRoutes };
